/** `stale`: the last stored prompts are shown instead; `none`: there was nothing to fall back on. */
export type PromptOfTheDayFallback = 'stale' | 'none';

type PromptOfTheDayEventCore = {
	eventType: 'operational';
	action: 'taskSuccess' | 'taskFail';
	actionSubject: 'promptOfTheDay';
	attributes: Record<string, unknown>;
};

/**
 * Event names and attribute names shared by every surface that shows the prompt of the day, so they
 * cannot drift apart. Surfaces add their own `source` and `actionSubjectId`.
 */
export const promptOfTheDayTaskSuccessEvent = ({
	promptCount,
	attributes = {},
}: {
	promptCount: number;
	attributes?: Record<string, unknown>;
}): PromptOfTheDayEventCore => ({
	eventType: 'operational',
	action: 'taskSuccess',
	actionSubject: 'promptOfTheDay',
	attributes: { ...attributes, promptCount },
});

export const promptOfTheDayTaskFailEvent = ({
	fallback,
	attributes = {},
}: {
	fallback: PromptOfTheDayFallback;
	attributes?: Record<string, unknown>;
}): PromptOfTheDayEventCore => ({
	eventType: 'operational',
	action: 'taskFail',
	actionSubject: 'promptOfTheDay',
	attributes: { ...attributes, fallback },
});
